import { token } from '@/infrastructure/container';
import { type IDomNavigation } from '@/services/DomNavigation';
import { type IDomKeyboard } from '@/services/DomKeyboard';

/**
 * Top-level boot coordinator. Starts the document-level DOM listeners (popstate, keydown) at
 * construction. Eager-resolved in main.tsx so the listeners attach before the first render.
 */
export class AppStore {
  constructor(nav: IDomNavigation, keyboard: IDomKeyboard) {
    keyboard.start();
    nav.start();
  }
}

export const TOKEN_AppStore = token<AppStore>('AppStore');
